import * as React from "react";
import { Popover, Input, Button, Tooltip } from "antd";

import trim from "lodash/trim";
import { Base64 } from "js-base64";
import WeaInput from "../../wea-input";
import WeaError from "../../wea-error";
import WeaLocaleProvider from "../../wea-locale-provider";
import isArray from "lodash/isArray";
import "../index.less";
import { Traditionalized, Simplized } from "../../wea-input-number/util";

const getLabel = WeaLocaleProvider.getLabel;

const LANG = {
  PREFIX: "~`~`",
  SPLITTER: "`~`",
  SUFFIX: "`~`~"
};

class WeaInputLocale extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      resultValue: "",
      value: "",
      list: {},
      languageidweaver: "7",
      errorMsg: ""
    };
  }

  static getList = function(multiStr, cb) {
    if (cb && typeof cb === "function") {
      const list = {};
      if (multiStr.indexOf(LANG.PREFIX) > -1) {
        multiStr = multiStr.substring(4);
        multiStr = multiStr.substring(0, multiStr.length - 4);
        multiStr.split(LANG.SPLITTER).map(item => {
          list[item.substr(0, 2)] = item.substr(2);
        });
      } else {
        return multiStr;
      }
      const resultObj = cb(list);
      const resultArr = Object.keys(resultObj).map(item => {
        return item + resultObj[item];
      });
      return LANG.PREFIX + resultArr.join(LANG.SPLITTER) + LANG.SUFFIX;
    }
    return multiStr;
  };

  static getCurrentLabel = (multiStr, langId) => {
    const localeLanguageId =
      langId || window.localStorage.getItem("languageidweaver") || "7";
    const list = {};
    if (typeof multiStr === "string" && multiStr.indexOf(LANG.PREFIX) > -1) {
      multiStr = multiStr.substring(4);
      multiStr = multiStr.substring(0, multiStr.length - 4);
      multiStr.split(LANG.SPLITTER).map(item => {
        list[item.substr(0, 2).replace(" ", "")] = item.substr(2);
      });
      return list[localeLanguageId] ? list[localeLanguageId] : "";
    } else {
      return multiStr;
    }
  };

  static getMultiStrFromBase64 = (baseStr = "") => {
    if (baseStr.indexOf("base64_") > -1) {
      let resultMulti = "";
      resultMulti = baseStr.substr(7);
      return Base64.decode(resultMulti);
    } else {
      return baseStr;
    }
  };

  static ref = {};

  componentDidMount() {
    let activeLanguageIds =
      window.localStorage.getItem("activeLanguageIds") || "['7']";
    // activeLanguageIds = JSON.stringify([
    //   "7",
    //   "8",
    //   // "9",
    //   // "12",
    //   // "13",
    //   // "14",
    //   "15",
    //   // "16",
    //   // "17",
    //   // "18"
    // ]);
    try {
      activeLanguageIds = JSON.parse(activeLanguageIds);
    } catch (error) {
      console.error("请检查 localStorage", error);
      activeLanguageIds = ["7"];
    }
    activeLanguageIds = isArray(activeLanguageIds) ? activeLanguageIds : ["7"];
    const list = {};
    activeLanguageIds.forEach((item, index) => {
      list[item] = "";
    });

    this.setState({ list }, () => {
      if (
        this.props.hasOwnProperty("value") &&
        this.props.value !== undefined
      ) {
        this.updatePropsValue(this.props.value, this.props);
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    // value 回显处理
    if ("value" in nextProps) {
      // console.log(nextProps.value, " | ", this.props.value)
      const value = nextProps.value || "";
      if (
        nextProps.value !== this.props.value ||
        value.indexOf("base64_") > -1
      ) {
        this.updatePropsValue(nextProps.value, nextProps);
      }
    }
  }

  getLanguageidweaver = () => {
    let localeLanguageId =
      window.localStorage.getItem("languageidweaver") ||
      this.state.languageidweaver;
    if (isNaN(Number(localeLanguageId))) {
      localeLanguageId = this.state.languageidweaver;
    }
    return localeLanguageId;
  };

  updatePropsValue = (value, nextProps = {}) => {
    const localeLanguageId = this.getLanguageidweaver();
    const { list } = this.state;
    if (value && nextProps.isBase64 && value.indexOf("base64_") > -1) {
      // remove base64_
      value = Base64.decode(value.substr(7));
      typeof this.props.onChange === "function" && this.props.onChange(value);
      typeof this.props.onBlur === "function" && this.props.onBlur(value);
    }
    // console.log('update props', list, value);
    if (value && value.indexOf(LANG.PREFIX) > -1) {
      // 多值
      value = value.substring(4);
      value = value.substring(0, value.length - 4);
      const tempArray = value.split(LANG.SPLITTER);
      // console.log(this.props.value)
      // console.log("list", list);
      // console.log(tempArray);
      const tempArrayKeys = [];
      tempArray.forEach(item => {
        let key = item.substr(0, 2).replace(/\s/g, "");
        tempArrayKeys.push(key);
        let value = item.substr(2);
        // console.log(item);
        // console.log("73", list, key);
        // 2019.1.22 去掉在这里更新 state list 的内容，会触发重绘
        if (list.hasOwnProperty(key)) {
          // 值在 active langeuage里面，就更新
          list[key] = trim(item.substr(2));
        }
        if (localeLanguageId == key) {
          // console.log(tempArray, key, value)
          this.setState({ value });
        }
      });

      Object.keys(list).forEach(item => {
        if (!tempArrayKeys.includes(item)) {
          list[item] = "";
        }
      });
      // console.log(list);
    } else {
      // 单值
      Object.keys(list).forEach(item => {
        list[item] = "";
      });
      list[localeLanguageId] = value;
      this.setState({ value });
    }
    // if (nextProps.value !== this.props.value) {
    const resultValue = this.getResultValue(
      list,
      localeLanguageId,
      "propUpdate"
    );
    this.setState({ resultValue });
    // }
  };

  confirm = () => {
    this.setState({
      visible: false
    });
    // console.log('pass resultvalue to onblur', this.state.resultValue, this.state);
    typeof this.props.onBlur === "function" &&
      this.props.onBlur(this.state.resultValue);
    typeof this.props.onChange === "function" &&
      this.props.onChange(this.state.resultValue);
    typeof this.props.onOk === "function" &&
      this.props.onOk(this.state.resultValue);
  };

  cancel = () => {
    this.setState({
      visible: false
    });
  };

  toggleClick = e => {
    const { visible } = this.state;
    e.stopPropagation();
    this.setState({
      visible: !visible
    });
  };

  updateMultiLang = (e, id) => {
    const localeLanguageId = this.getLanguageidweaver();
    const { list } = this.state;
    let value = "";
    if (e.target) {
      value = e.target.value;
    } else {
      value = e;
    }
    list[id] = value;

    const resultValue = this.validateLength(() => {
      return this.getResultValue(list, id);
    }, id);
    // console.log(list, resultValue);
    this.props.onChange && this.props.onChange(resultValue);
    this.props.onBlur && this.props.onBlur(resultValue);
    this.setState({ value: list[localeLanguageId], resultValue });
  };

  getResultValue = (list, id, source) => {
    let resultValue = "";
    if (source !== "propUpdate") {
      if (Object.keys(list).includes("7") && Object.keys(list).includes("9")) {
        list = this.handleTraditionalizedorSimplized(list, id);
      }
    }
    // console.log(list);
    let temp = [];
    Object.keys(list)
      .reverse()
      .forEach(id => {
        this.setState({ value: list[id] });
        if (list[id] !== "") {
          temp.push(`${id} ${trim(list[id])}`);
        }
      });
    // console.log('temp', temp, 'list', list, 'id', id);
    if (temp.length === 1) {
      resultValue = temp.toString().substr(2);
    } else if (temp.length === 0) {
      resultValue = "";
    } else {
      resultValue =
        LANG.PREFIX + temp.reverse().join(LANG.SPLITTER) + LANG.SUFFIX;
    }
    return resultValue;
  };

  handleTraditionalizedorSimplized = (list, id) => {
    if (this.state.visible) {
      if (id === "7" && list["7"]) {
        list[9] = Traditionalized(list[id]);
      }
      this.setState({ list });
    }
    return list;
  };

  popOverChange = v => {
    this.setState({ visible: v });
    if (v === false) {
      this.confirm();
    }
  };

  validateLength(cb, id) {
    const { list } = this.state;
    const { i18nLengthValidate } = this.props;
    const currentLabel = list[id];
    // 有验证规则
    if (i18nLengthValidate && i18nLengthValidate.hasOwnProperty("maxLength")) {
      const langKinds = Object.keys(list).length;
      const limitLength = Number(i18nLengthValidate.maxLength);
      const reg = /^[a-z0-9\s]+$/i;
      const bolRes = reg.test(currentLabel);
      // 数字除 1 中文除 3
      const divisor = bolRes ? 1 : 3;
      const perLangLength = Math.floor(
        (limitLength -
          (langKinds - 1) * LANG.SPLITTER.length -
          LANG.PREFIX.length -
          LANG.SUFFIX.length) /
          langKinds /
          divisor
      );
      if (currentLabel.length > perLangLength) {
        // 提示错误信息
        this.setState(
          {
            errorMsg: `${getLabel(
              "506875",
              "名称长度不能超过"
            )}${perLangLength}${getLabel("391259", "字符")}`
          },
          () => {
            this.refs.weaError.showError();
          }
        );
        // 截取字符，处理受控
        list[id] = currentLabel.substring(0, perLangLength);
        // 这里需要强制更新，可能是WeaInput受控没有处理好，导致截取了以后UI没有变化，但是实际state已经改变
        this.setState({ list }, () => {
          this.forceUpdate();
        });
        return this.getResultValue(list, id);
      } else {
        return cb();
      }
      // 无验证规则
    } else {
      return cb();
    }
  }

  onKeyDown = e => {
    if (e.keyCode == 13) {
      const { onEnter, onEnterSearch } = this.props;
      const value = e.target.value;
      typeof onEnterSearch === "function" && onEnterSearch(value); // 高级搜索传参
      typeof onEnter === "function" && onEnter(value);
    }
  };

  render() {
    const localeLanguageId = this.getLanguageidweaver();
    const { list, value, resultValue } = this.state;
    // console.log('render', value, list)
    let {
      viewAttr,
      style,
      hasBorder,
      underline,
      helpfulTip,
      helpfulTipProps,
      customBlur,
      i18nLengthValidate,
      className = ""
    } = this.props;

    const renderContent = Object.keys(list).map((item, index) => {
      return (
        <label key={index} className="wea-input-locale-popover-content-label">
          <img
            className="wea-input-locale-popover-content-label-img"
            src={`/images/ecology9/multiLang/multilang_${item}.png`}
            alt=""
          />
          <Input
            value={list[item]}
            onChange={e => this.updateMultiLang(e, item)}
            className="wea-input-locale-popover-content-label-input"
            onBlur={e => {
              list[item] = trim(list[item]);
              const resultValue = this.getResultValue(list, item);
              this.setState({ list, resultValue });
              typeof customBlur === "function" && customBlur(resultValue);
            }}
            onKeyDown={this.onKeyDown}
          />
        </label>
      );
    });
    const content = (
      <div>
        {renderContent}
        <hr
          style={{ marginTop: 10, marginBottom: 10, border: "1px solid #eee" }}
        />
        <div className="wea-input-locale-popover-button-group">
          <Button
            style={{ marginRight: 10 }}
            onClick={this.confirm}
            type="primary"
          >
            {getLabel("33703", "确认")}
          </Button>
          <Button onClick={this.cancel}>{getLabel("31129", "取消")}</Button>
        </div>
      </div>
    );

    // 防止死循环调用
    let { props } = this;
    delete props.inputType;
    // console.log(this.props);
    // console.log('render', list, localeLanguageId);
    // console.log(resultValue);
    if (viewAttr == "1") {
      return (
        <WeaInput
          {...props}
          defaultValue={list[localeLanguageId]}
          value={list[localeLanguageId]}
        />
      );
    }
    if (i18nLengthValidate === undefined) {
      i18nLengthValidate = {};
    }
    return (
      <div className={`wea-input-locale-container ${className}`} style={style}>
        <div className="wea-default-input-locale">
          <WeaError
            style={{ width: "100%" }}
            tipPosition={i18nLengthValidate.tipPosition || "top"}
            error={
              this.state.errorMsg + (i18nLengthValidate.errorMessage || "")
            }
            ref="weaError"
          >
            <WeaInput
              {...props}
              style={{}}
              onChange={e =>
                this.updateMultiLang(e, localeLanguageId.toString())
              }
              defaultValue={list[localeLanguageId]}
              value={list[localeLanguageId]}
              // 标记 WeaInput 处于 WeaInputLocale 中
              modeSource={"weaInputLocale"}
              // 有些组件会触发onBlur导致点击清空数据
              onBlur={e => {
                typeof customBlur === "function" &&
                  customBlur(this.getResultValue(list, localeLanguageId));
              }}
            />
          </WeaError>
        </div>
        <div
          ref={ref => (this.ref = ref)}
          onClick={e => this.toggleClick(e)}
          className={`wea-input-locale-input`}
          // style={style}
        >
          <Popover
            onVisibleChange={v => this.popOverChange(v)}
            visible={this.state.visible}
            trigger="click"
            placement="bottom"
            content={content}
            overlayStyle={{
              width:
                this.ref &&
                (this.ref.clientWidth < 224 ? 224 : this.ref.clientWidth)
              // left: 0, top: 30,
            }}
          >
            <div>
              {resultValue && resultValue.indexOf(LANG.PREFIX) > -1 ? (
                <div class="wea-input-locale-earth-icon">
                  <Tooltip
                    placement="right"
                    title={getLabel("385819", "已设置多语言")}
                  >
                    <img
                      src="/images/ecology9/multiLang/seted-multi-lang.png"
                      alt=""
                    />
                  </Tooltip>
                </div>
              ) : (
                <div class="wea-input-locale-earth-icon">
                  <Tooltip
                    placement="right"
                    title={getLabel("385828", "未设置多语言")}
                  >
                    <img
                      src="/images/ecology9/multiLang/unset-multi-lang.png"
                      alt=""
                    />
                  </Tooltip>
                </div>
              )}
            </div>
          </Popover>
        </div>
      </div>
    );
  }
}

export default WeaInputLocale;



// WEBPACK FOOTER //
// ./ecology9/wea-input-locale/component/weaInputLocale.js